import React from 'react'
import { Redirect, Route, RouteProps, Switch } from 'react-router-dom'
import { RouteConfig } from './interface'
import PageLoading from './PageLoading'
import routeConfig from './config'
import { getRouteMenus } from './utils'

// 修复 React 18 与 react-router-dom v5 的类型兼容问题
const RouteComponent = Route as any
const SwitchComponent = Switch as any
const RedirectComponent = Redirect as any

const BlankLayout = React.lazy(
  () => import(/* webpackChunkName: "BlankLayout" */ '@/layouts/BlankLayout'),
)

const renderRouteChildren = (routes: RouteConfig[] = []) => {
  return routes.map(({ children, layout, redirect, component, sideMenu, path, ...rest }) => {
    const props: RouteProps = { path }

    if (children) {
      const Layout = layout ? React.lazy(layout) : BlankLayout
      const childrenRoutes = renderRouteChildren(children)

      const sideMenuComponent = sideMenu ? (
        React.createElement(React.lazy(sideMenu), {
          title: rest.title,
          sideMenu: getRouteMenus(children),
        })
      ) : (
        <></>
      )

      props.exact = false
      props.render = (layoutProps: any) => (
        <React.Suspense fallback={React.createElement(PageLoading)}>
          {React.createElement(
            Layout,
            {
              ...rest,
              ...layoutProps,
              sideMenu: sideMenuComponent,
            },
            <SwitchComponent>{childrenRoutes}</SwitchComponent>,
          )}
        </React.Suspense>
      )
    } else if (redirect) {
      props.exact = true
      props.render = () => <RedirectComponent to={redirect} />
    } else if (component) {
      const Component = React.lazy(component)

      props.exact = true
      props.render = (routeProps: any) => (
        <React.Suspense fallback={React.createElement(PageLoading)}>
          {React.createElement(Component, { ...rest, ...routeProps })}
        </React.Suspense>
      )
    } else {
      throw new Error('路由配置错误，至少包含 [ children | component | redirect ] 之一')
    }

    return <RouteComponent key={path} {...props} />
  })
}

export default function Router() {
  const routes = React.useMemo(() => renderRouteChildren(routeConfig), [])

  return (
    <React.Suspense fallback={React.createElement(PageLoading)}>
      <SwitchComponent>{routes}</SwitchComponent>
    </React.Suspense>
  )
}
